import { useMutation } from '@tanstack/react-query';
import { Form, Image, Input } from 'antd';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import ToastError from '../../components/Toast/ToastError';
import { CreateContactDto, LoginDto } from '../../apis/client-axios';
import ButtonWrap from '../../components/ButtonWrap';
import CustomInputAuthen from '../../components/InputAuthencation';
import './style.scss';
import { TextAreaProps } from 'antd/es/input';
import { contactApi } from '../../apis';
import ToastSuccess from '../../components/Toast/ToastSuccess';
import { useForm } from 'antd/es/form/Form';

const n = (key: keyof CreateContactDto) => key;

const Contact = () => {
  const intl = useIntl();
  const logo = useSelector((state: RootState) => state.setting.logo);
  const [form] = useForm();

  const sendContactMutation = useMutation({
    mutationFn: (payload: CreateContactDto) => contactApi.contactControllerCreate(payload),
    onSuccess: () => {
      ToastSuccess({ content: intl.formatMessage({ id: 'contact.success' }) });
    },
    onError: () => {
      ToastError({ content: intl.formatMessage({ id: 'contact.error' }) });
    },
  });

  const onFinish = (values: CreateContactDto) => {
    sendContactMutation.mutate(values);
  };

  return (
    <div className="row justify-content-center align-items-center main_sign-in">
      <div className={`image-sign-in${logo === 'images/mos-main.png' || !logo ? ' image-sign-in-default' : ''}`}>
        {
          <Image
            width={200}
            height={200}
            src={logo || 'images/mos-main.png'}
            alt={logo || 'images/mos-main.png'}
            fallback="images/mos-main.png"
            preview={false}
          />
        }
      </div>
      <Form
        name="basic"
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
        requiredMark={false}
        className="sign-in contact-form"
        form={form}
      >
        <h1 className="sign-in__title">{intl.formatMessage({ id: 'contact.title' })}</h1>
        <div className="sign-in__container">
          <div className="sign-in__container-input">
            <Form.Item
              name={n('name')}
              rules={[{ required: true, message: intl.formatMessage({ id: 'common.require' }) }]}
            >
              <CustomInputAuthen placeholder={intl.formatMessage({ id: 'contact.name' })} height={48} width={342} />
            </Form.Item>
            <Form.Item
              name={n('email')}
              rules={[
                { required: true, message: intl.formatMessage({ id: 'common.require' }) },
                { type: 'email', message: intl.formatMessage({ id: 'account-form.email.validate' }) },
              ]}
            >
              <CustomInputAuthen placeholder={intl.formatMessage({ id: 'contact.email' })} height={48} width={342} />
            </Form.Item>
            <Form.Item
              name={n('subject')}
              rules={[{ required: true, message: intl.formatMessage({ id: 'common.require' }) }]}
            >
              <CustomInputAuthen placeholder={intl.formatMessage({ id: 'contact.subject' })} height={48} width={342} />
            </Form.Item>
            <Form.Item
              name={n('content')}
              rules={[{ required: true, message: intl.formatMessage({ id: 'common.require' }) }]}
            >
              <CustomInputAuthen
                placeholder={intl.formatMessage({ id: 'contact.content' })}
                type="textarea"
                props={{ autoSize: { minRows: 5 }, style: { borderRadius: '20px' } } as TextAreaProps}
              />
            </Form.Item>
          </div>
        </div>
        <Form.Item>
          <ButtonWrap
            disabled={sendContactMutation.isPending}
            htmlType="submit"
            variant="filled"
            color="primary"
            width={342}
            height={56}
          >
            {intl.formatMessage({ id: 'contact.submit' })}
          </ButtonWrap>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Contact;
